<template>
  <base-modal
    :id="modalId"
    :ok-handler="okHandler"
    :title="title"
    :ok-button-text="okButtonText"
    :ok-button-class="okButtonClass"
  >
    <div>
      <div v-if="recipToDelete">
        Are you sure you want to delete <strong>{{ recipToDelete.firstName }} {{ recipToDelete.lastName }}</strong>?
      </div>
      <div v-else>
        Are you sure you want to delete this recipient?
      </div>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal';
import modalNames from '../../util/modalNames';
export default {
  name: 'DeleteRecipConfirmationModal',
  components: { BaseModal },
  props: {
    title: {
      type: String,
      default: 'Delete Recipient',
    },
    content: {
      type: String,
      default: '',
    },
    okButtonText: {
      type: String,
      default: 'OK',
    },
    okButtonClass: {
      type: String,
      default: 'btn-warning',
    }
  },
  data() {
    return {
      modalId: modalNames.DELETE_RECIPIENT_CONFIRMATION_MODAL,
    }
  },
  computed: {
    recipToDelete: function()  {
      if (this.$store.getters.getUser) {
        console.log('this.$store.getters.getRecipToDelete ', this.$store.getters.getRecipToDelete);
        return this.$store.getters.getRecipToDelete;
      }
      return null;
    }
  },
  methods: {
    okHandler: function() {
      const payload = {
        vm: this,
        recip: this.recipToDelete.id,
      };
      this.$store.dispatch('deleteRecipient', payload);
    },
  },
}
</script>
